import { createLogger } from '@packages/shared';
import posthog from 'posthog-js';

/** Sends logs to PostHog: `log.info`, `log.warn` and `log.error` (see `createLogger`). */
export const log = createLogger({ posthog, isTestMode: false, isDev: import.meta.env.DEV });
